<template>
  <div id="charge-modal">
    <!-- MODAL DE COBRANÇA -->
    <PmwModal
      v-if="singleData !== null"
      :value="value"
      title="Cobrança de No-Show"
      description="Confira as informações de No-Show."
      preventOverlayClick
      @modal-cancel="$emit('cancel', $event)"
    >
      <!-- PRIMEIRA LINHA DE CONTEÚDO -->
      <div class="pmw-modal">
        <div class="modal-item">
          Código de Reserva
          <div class="modal-item--content">
            {{ singleData.reserva }}
          </div>
        </div>

        <div class="modal-item">
          Hóspede
          <div class="modal-item--content__name">
            {{ singleData.hospedeReservante }}
          </div>
        </div>
      </div>

      <!-- SEGUNDA LINHA DE CONTEÚDO -->
      <div class="pmw-modal--second">
        <div class="modal-item">
          Data de Check in
          <div class="modal-item--content">
            {{ singleData.checkin }}
          </div>
        </div>

        <div class="modal-item--firstValue">
          Valor 1º Diária
          <div class="modal-item--content">
            {{
              converToCurrency(
                singleData.valorPrimeiraDiaria.valor,
                0,
                singleData.valorPrimeiraDiaria.moeda
              )
            }}
          </div>
        </div>

        <div class="modal-item">
          Valor Taxas
          <div class="modal-item--content">
            {{
              converToCurrency(
                singleData.valorTaxasPrimeiraDiaria.valor,
                0,
                singleData.valorTaxasPrimeiraDiaria.moeda
              )
            }}
          </div>
        </div>

        <div class="modal-item">
          Valor Cobrança
          <div class="modal-item--content">
            {{
              converToCurrency(
                singleData.valorReal +
                  singleData.valorTaxasPrimeiraDiaria.valor,
                0,
                singleData.valorTotal.moeda
              )
            }}
          </div>
        </div>
      </div>

      <template #footer-content>
        <!-- CANCELAR -->
        <PmwButton
          variation="pmw-primary"
          size="large"
          layout="outline"
          class="pmw-modal--content-button"
          @click="$emit('cancel', $event)"
        >
          Voltar
        </PmwButton>

        <!-- CONFIRMAÇÃO -->
        <PmwButton
          :disabled="btnDisable"
          variation="pmw-primary"
          size="large"
          class="pmw-modal--content-button"
          @click="$emit('confirm', singleData.reserva)"
        >
          Cobrar No-Show
        </PmwButton>
      </template>
    </PmwModal>
  </div>
</template>

<script>
/** Componentes */

/** Biblioteca */
import PmwModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwModal'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'

/** Locais */
import { converToCurrency } from '@/helpers/math'

export default {
  name: 'ChargeModal',
  components: {
    PmwModal,
    PmwButton
  },
  props: {
    /** Dados da reserva selecionada */
    singleData: {
      type: Object,
      default: () => {}
    },
    /** Define se o modal dever ser ou não aberto */
    value: {
      type: Boolean,
      default: false
    },
    /** Define se o botão deve ser desabilitado */
    btnDisable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    converToCurrency: converToCurrency
  }
}
</script>

<style lang="scss" scoped>
.pmw-modal {
  display: flex;
  margin: 0 auto;
  &--second {
    display: flex;
    margin: 0 auto;
    margin-top: 50px;
  }
}

.modal-item {
  font-weight: font-weight('weight-medium');
  margin-right: 24px;

  &--content {
    margin-top: 10px;
    margin-left: 1px;
    font-weight: font-weight('weight-normal');

    &__name {
      margin-top: 10px;
      margin-left: 0px;
      font-weight: font-weight('weight-normal');
    }
  }

  &--firstValue {
    font-weight: font-weight('weight-medium');
    margin-left: 15px;
    margin-right: 24px;
  }
}
</style>
